import React from "react";
import CustomerContainer from "../containers/Customer";

const Customer = () => {
  return <CustomerContainer />;
};

export default Customer;
